import { JobResource, HolidayEntry, SourceNode, RequestStatus, SubEmployee } from "../types";
import { getCategoryId } from "../../../../pages/event/helpers";
import { status } from "../stores/stores";
import { addToBackendData, backendData } from "./utilsStaffplan";
import Times from 'icon:times';
import translate from "../../../../i18n";
import { sourceNodeStore } from '../stores/stores';
import logError from "../../../../utils/log-error";
import { EmployeeType } from "../../types";

let anfragenvariante = '';
let jobResources: any;
let classesArray = [
    RequestStatus.REQUESTED, RequestStatus.AVAILABLE, RequestStatus.BOOKED, 
    RequestStatus.REJECTED, RequestStatus.NV, RequestStatus.NA
];
let mainjobOrProjectId:number;
let isProject:boolean;

status.subscribe(value => {
	anfragenvariante = value;
});

sourceNodeStore.subscribe((sourceNode: SourceNode) => {
    if ( !sourceNode )
        return;
    mainjobOrProjectId = sourceNode.ID;
    isProject = sourceNode.Subtyp === 'P';
});

function getResources() {
    const url = `${window.location.origin}/api/`+( isProject ? 'projekt' : 'job')+`/${mainjobOrProjectId}/staffplan`;
	fetch(url)
    .then(res => {
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
    })
    .then(data => {
        jobResources = Object.values(data)[1];
    })
    .catch(error => {
        logError(`Error getting resources with "url": ${url}, mainjobOrProjectId: ${mainjobOrProjectId}`, error.stack);
    })
}


async function checkForDuplicates(currentElement: any, terminID: any, zugehoerigkeit:any, zugehoerigkeitID: any, name: string) {
	let selector = `td[data-terminid='${terminID}'][data-zugehoerigkeitid='${zugehoerigkeitID}'][data-zugehoerigkeit='${zugehoerigkeit}']`;

	if (zugehoerigkeitID === 0) {
		selector += `[data-freierMitarbeiter='${name}']`;
	}

	let sameTerminIdElements = document.querySelectorAll(selector);

	if(zugehoerigkeit !== 'D') {
		sameTerminIdElements.forEach(element => {
			classesArray.forEach(cls => {
				if(element !== currentElement && element.classList.contains(cls)) {
					element.classList.remove(cls);
				};
			});
		});
	}
	
}

async function changeClassNameAndAddToBackendData(
	e : Event,
	terminid: number,
	zugehoerigkeit: string,
	zugehoerigkeitid: number,
	name: string,
	subEmployeeId: 0 | null,
)  {

	const target = e.target as HTMLElement;
    let td;
	let checkValue;

    if (target.tagName === 'TD') {
        td = target;
    } else if (target.parentElement && target.parentElement.tagName === 'TD') {
        td = target.parentElement;
    } else {
        return;
    }
	await checkForDuplicates(td, terminid, zugehoerigkeit, zugehoerigkeitid, name);
	if (td.className === 'center staffplan-cell ' + anfragenvariante || anfragenvariante === '') {
		td.className = 'center staffplan-cell ';
		checkValue = false;
	} else {
		td.className = 'center staffplan-cell ' + anfragenvariante;
		checkValue = true;
	}

	let resourceWithID;
	if (jobResources && jobResources.length > 0) {
    	resourceWithID = jobResources.find(
        	(resource: JobResource) => resource.ZugehoerigkeitID === zugehoerigkeitid && resource.hasOwnProperty('ID')
    	);
	}

	let trElement = target.closest('tr');
	
	const temaid = resourceWithID ? resourceWithID.ID : 'neu';

	const kategorieid = getCategoryId(trElement);


	let resourceName = null;

	if(zugehoerigkeitid === 0) {
		resourceName = name;
	}
	addToBackendData(terminid, zugehoerigkeit, zugehoerigkeitid, kategorieid, checkValue, temaid, backendData, resourceName, subEmployeeId, null);

	e.stopPropagation();
};


function removeDataFromBackend(newRow, backendData) {
    let staffplanCells = newRow.querySelectorAll('td.staffplan-cell');
    
    for (let cell of staffplanCells) {
        let zugehoerigkeitid = cell.getAttribute('data-zugehoerigkeitid');
        let zugehoerigkeit = cell.getAttribute('data-zugehoerigkeit');
        let terminid = cell.getAttribute('data-terminid');

        // Check if there is an object in backendData that has the same values
        for (let i = 0; i < backendData.length; i++) {
            if (backendData[i].zugehoerigkeitid == zugehoerigkeitid && backendData[i].zugehoerigkeit == zugehoerigkeit && backendData[i].terminid == terminid) {
                // Remove the object from backendData
                backendData.splice(i, 1);
                break;
            }
        }
    };

    newRow.remove();
}

export async function findSubEmployees(zugehoerigkeitID: number) {
	
		const url = `${window.location.origin}/api/assignmentsearch`;

		const requestData = {
			mode: `subcontractoremployees-${zugehoerigkeitID}`,
			search: null,
		};

		try {
			const response = await fetch(url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(requestData),
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			const data = await response.json();
			const subEmployees = data.filter((employee: SubEmployee) => employee.type === 'entry');
			return subEmployees
		} catch (error) {
			logError(`Error getting subEmployees with "url": ${url}, zugehoerigkeitID: ${zugehoerigkeitID}`, error.stack);
		}
	
};

export function addRowToStaffplanOnDrop(row: HTMLTableRowElement, target: any, id: any, name: any, type: any, tbody: any, prevRefRow: any, categoryId: any, subEmployeeId: 0 | null, subEmployees: SubEmployee[] ) {

    getResources();
	const newRow = document.createElement('tr');
	newRow.dataset.zugehoerigkeitid = id;
    newRow.dataset.zugehoerigkeit = type === EmployeeType.Freelancer ? EmployeeType.Employee : type;
    if ( categoryId !== '' && categoryId !== 0 )
        newRow.dataset.kategorieid = categoryId;

	let holidayArray = null;
	let inputEl = document.querySelector('input[name=terminid]') as HTMLInputElement;
	let hauptTerminId = inputEl.value;
		
	if(type === 'D') {
		let displaySelectSubEmployeesList = false;
		let selectedSubEmployee : SubEmployee = null;


		function toggleSearchFilterDisplay() {
			if(subEmployees.length > 0) {
				displaySelectSubEmployeesList = true;
				updateDiv();
			}
		};

		function selectSubEmployee(e) {
			let selectedId = e.target.value;
			selectedSubEmployee = subEmployees.find(subEmployee => subEmployee.id == selectedId);
		};
	
		 function updateDiv() {
			if (displaySelectSubEmployeesList) {
					newRow.innerHTML = `
				<td >
				<div class="name-and-icons" style="justify-content: space-between">
					<div class="select-wrapper width200 dlma-subemployee-selectfield-0" style="display: block;">
						<select name="subemployee-selectfield-0">
						<option value="0">${translate('pleaseChoose')}...</option> 
						${subEmployees.map(subEmployee => `<option value="${subEmployee.id}">${subEmployee.title}</option>`).join('')}
						</select>

						<svg
						class="icon icon--chevron-down arrow-down"
						focusable="false"
						role="img"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 448 512"
						><!-- Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --><path
							d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
						/></svg
					>

					</div>
					<button type="button" class="button icon-button delete-ma"
					data-confirm="${translate('confirmRemoveResource')}"
					data-label="${translate('delete')}"
					aria-label="${translate('delete')}">${Times()}</button>
					</div>
				</td>
				`;	
				let deleteRowButton = newRow.querySelector('.delete-ma');

				
				deleteRowButton.addEventListener('click', function() {
				    removeDataFromBackend(newRow, backendData);
				});

				target
				.querySelector('thead tr')
				.querySelectorAll('th')
				.forEach((cell: any, i: any) => {
				
					if (cell.classList.contains('transparent')) {
						const td = document.createElement('td');
						td.className = 'dragndrop icon';
						td.innerHTML =
							'<svg class="icon icon--sort blue" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"></path></svg>';
						newRow.append(td);
						return;
					}
				
					if (cell.classList.contains('space')) {
						const td = document.createElement('td');
						if (cell.classList.contains('black')) {
							td.className = 'space black';
						} else {
							td.className = 'space';
						}
						newRow.append(td);
						return;
					}
				
					if (i === 0) {
						return;
					}
                                
					if (cell.classList.contains('center')) {
						let terminid = cell.getAttribute('data-terminid');
						let datumVon = cell.getAttribute('data-datum-von');
						let zugehoerigkeit = type;
						let zugehoerigkeitid = id;
					
						const td = document.createElement('td');
						td.className = 'center staffplan-cell ';
						td.setAttribute('data-datumVon', datumVon);
						td.setAttribute('data-zugehoerigkeitid', zugehoerigkeitid);
            		    td.setAttribute('data-zugehoerigkeit', type === EmployeeType.Freelancer ? EmployeeType.Employee : type);
            		    if ( categoryId !== '' && categoryId !== 0 )
						td.setAttribute('data-kategorieid', categoryId);
						td.setAttribute('data-terminid', terminid);
						if(zugehoerigkeitid === 0) {
							td.setAttribute('data-freierMitarbeiter', name);
						}
						const labelElement = document.createElement('label');
						labelElement.className = 'active span-drop-resource ';
					
						td.onclick = e => changeClassNameAndAddToBackendData(e, terminid, zugehoerigkeit, zugehoerigkeitid, name, selectedSubEmployee.id );
					
						td.append(labelElement);
						newRow.append(td);
						return;
					};
			});	
			} else {
				let underlineClass = subEmployees.length > 0 ? 'hover-underline' : '';
				let pointerClass = subEmployees.length > 0 ? 'dienstleister-pointer': '';
				
				newRow.innerHTML = `
				<td>
					<div class="name-and-icons" style="justify-content: space-between">
						<div class="status-holder status-holder--text ${pointerClass}">
							<span class="text nowrap ${underlineClass}">${name}</span>
						</div>
						<button type="button" class="button icon-button delete-ma"
						data-confirm="${translate('confirmRemoveResource')}"
						data-label="${translate('delete')}"
						aria-label="${translate('delete')}">${Times()}</button>
					</div>
				</td>
				`;	
			}

			const selectElement = newRow.querySelector('select[name="subemployee-selectfield-0"]');
			if (selectElement) {
				selectElement.addEventListener('change', selectSubEmployee);
			}
	
			const divElement = newRow.querySelector('.status-holder');
			if (divElement) {
				divElement.addEventListener('click', toggleSearchFilterDisplay);
			}
		}
	
		updateDiv();
	} else {
		newRow.innerHTML = `
		<td>
			<div class="name-and-icons">
				<span>${name}</span>
				<button type="button" class="button icon-button delete-ma"
				data-confirm="${translate('confirmRemoveResource')}"
                data-label="${translate('delete')}"
                aria-label="${translate('delete')}">${Times()}</button>
			</div>
		</td>
	`;
	}

	let deleteRowButton = newRow.querySelector('.delete-ma');

	deleteRowButton.addEventListener('click', function() {
		removeDataFromBackend(newRow, backendData);
	});

	target
		.querySelector('thead tr')
		.querySelectorAll('th')
		.forEach((cell: any, i: any) => {

			if (cell.classList.contains('transparent')) {
				const td = document.createElement('td');
				td.className = 'dragndrop icon';
				td.innerHTML =
					'<svg class="icon icon--sort blue" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"></path></svg>';
				newRow.append(td);
				return;
			}

			if (cell.classList.contains('space')) {
				const td = document.createElement('td');
				if (cell.classList.contains('black')) {
					td.className = 'space black';
				} else {
					td.className = 'space';
				}
				newRow.append(td);
				return;
			}

			if (i === 0) {
				return;
			}
                                
			if (cell.classList.contains('center')) {
				let terminid = cell.getAttribute('data-terminid');
				let datumVon = cell.getAttribute('data-datum-von');
				let zugehoerigkeit = type;
				let zugehoerigkeitid = id;

				const td = document.createElement('td');
				td.className = 'center staffplan-cell ';
				td.setAttribute('data-datumVon', datumVon);
				td.setAttribute('data-zugehoerigkeitid', zugehoerigkeitid);
                td.setAttribute('data-zugehoerigkeit', type === EmployeeType.Freelancer ? EmployeeType.Employee : type);
                if ( categoryId !== '' && categoryId !== 0 )
				td.setAttribute('data-kategorieid', categoryId);
				td.setAttribute('data-terminid', terminid);
				if(zugehoerigkeitid === 0) {
					td.setAttribute('data-freierMitarbeiter', name);
				}
				const labelElement = document.createElement('label');
				labelElement.className = 'active span-drop-resource ';

				td.onclick = e => changeClassNameAndAddToBackendData(e, terminid, zugehoerigkeit, zugehoerigkeitid, name, subEmployeeId );

				td.append(labelElement);
				newRow.append(td);
				return;
			};
		});	
        
    	try {
            tbody.insertBefore(newRow, prevRefRow);
        } catch {
            tbody.insertBefore(newRow, prevRefRow.nextSibling);
        }

        $(tbody.closest('table')).tableDnDUpdate();

        if (type != 'D' && id !== 0) {
            fetch(`${window.location.origin}/api/job/${hauptTerminId}/staffplan/${type}:${id}`)
                .then(res => res.json())
                .then(data => {
                    holidayArray = data.Urlaube;
                    let holidayDataEntries = Object.entries(holidayArray);
                    if(holidayDataEntries.length > 0) {
                        holidayDataEntries.forEach(([key, val]: [string, HolidayEntry]) => {
                            let color = val.Farbe;
                            let keyInNewFormat = key.split('-').reverse().join('.');

                            newRow.childNodes.forEach((child: ChildNode) => {
                                if (child.nodeType === Node.ELEMENT_NODE) {
                                    let element = child as HTMLElement;
                                    if (element.dataset.datumvon == keyInNewFormat) { 
                                        element.classList.add('na', color);
                                    }
                                }
                            });
                        });
                    }
                });
        }
};